import Vue from 'vue'

import axios from 'axios'

export const delay = (ms: number, callback?: Function) => {
    let handle: number|null = null
    return function (f?: Function) {
        window.clearTimeout(handle)
        let cb = callback || f || (function () {})
        handle = window.setTimeout(cb.bind(this), ms)
    }
}

// chain several validators together
export const chain = (key: string, ...handlers: Function[]) => {
    return function () {
        const self = this
        this.errors[key] = handlers.reduce((prev: string, handler: Function)  => (prev ? prev : handler.call(self, key)), '')
    }
}

export const required = function (key: string) {
    let val = this.form[key]
    if (typeof val === 'string' || val instanceof String) { val = val.trim().length }
    return (val ? '' : 'required')
}

export const valid_email = function (key: string) {
    // https://vuejs.org/v2/cookbook/form-validation.html#Using-Custom-Validation
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(this.form[key].trim()) ? '' : 'invalid'
}

const watch = (key: string) => delay(100, function () {
    this.$data.validation[key].call(this)
})


interface IForm {
    [key: string]: string
}

interface IErrors {
    [key: string]: string
}

interface IValidations {
    [key: string]: Function
}

const data = (validations: IValidations) => {
    const form: IForm = {}
    const errors: IErrors = {}
    Object.keys(validations).forEach(key => { form[key] = '' ; errors[key] = '' })
    return {
        form: form,
        errors: errors,
        validation: validations,
        submitting: false,
    }
}

const watchers = (validations: IValidations) => {
    const out: any = {}
    Object.keys(validations).forEach(key => { out['form.' + key] = { handler: watch(key) } })
    return out
}


export const FormValidation = (Template: Vue.VueConstructor, validations: IValidations) => Vue.extend({
    extends: Template,
    data: () => data(validations),
    watch: watchers(validations),
    computed: {
        has_errors() {
            return Object.keys(this.$data.errors).filter(key => Boolean(this.$data.errors[key])).length > 0
        },
    },
    methods: {
        // onBlur
        validate(event: Event) {
            this.check((event.target as any).name)
        },
        check(key: string) {
            const handler = this.$data.validation[key]
            if (handler) { handler.call(this) }
            //this._watchers.find(w => w.expression === 'form.' + key).cb.call(this, this.$data.form[key])
        },
        stop(event: Event, submitting: boolean = false) {
            event.stopImmediatePropagation()
            event.stopPropagation()
            event.preventDefault()
            this.submitting = submitting
            if (this.post_error) { this.post_error() }
            return false
        },
        submit(event: Event) {
            if (this.submitting && ! this.has_errors) { return true }
            try {
                this.submitting = true
                Object.keys(this.$data.validation).forEach(key => this.check(key))
                this.$forceUpdate()
                if (this.has_errors) { return this.stop(event) }

                axios({
                    method       : 'put',
                    url          : this.$refs.form.action,
                    responseType : 'json',
                    data         : this.$data.form,
                })
                .then(({data: { errors }}) => {
                    Object.keys(errors).forEach(key => this.$data.errors[key] = errors[key])
                    this.$forceUpdate()
                    if (errors === true || this.has_errors) {
                        this.submitting = false
                        if (this.post_error) { this.post_error() }
                        return
                    }
                    this.$refs.form.submit()
                })
                .catch((err) => {
                    console.error(err)
                    this.submitting = false
                    if (this.post_error) { this.post_error() }
                })
            }
            catch (err) {
                console.error(err)
                return this.stop(event)
            }
            return this.stop(event, true)
        },
    },
})
